import React, { useState, useEffect, useContext } from "react";
import Filter from "./Filter";
import axios from "axios";
import api from "../api/api";
import { FilterContext } from "../context/FilterContext";

let webURL = "/";
if(!window.location.host.includes("localhost")){
  webURL = "/apps/investor_list/"
} 

function FilterSidebar(props) {
  const [orgs, setOrgs] = useState({});
  const [demo, setDemo] = useState({});
  const [states, setStates] = useState({});
  const [tech, setTech] = useState({});
  const [owner, setOwner] = useState({});
  const [reset, doReset] = useState(0);
  const { selectedOrgs } = useContext(FilterContext);



  useEffect(() => {
    const fetchData = () => {
      axios.get(`${webURL}organizations.json`).then((res) => {
        //console.log(res)
        setOrgs(res.data);
      });

      axios.get(`${webURL}demographics.json`).then((res) => {
        //console.log(res)
        setDemo(res.data);
      });

      axios.get(`${webURL}states.json`).then((res) => {
        //console.log(res)
        setStates(res.data);
      });

      axios.get(`${webURL}technologies.json`).then((res) => {
        //console.log(res)
        setTech(res.data);
      });

      axios.get(`${webURL}ownership.json`).then((res) => {
        //console.log(res.data)
        setOwner(res.data);
      });
    };

    fetchData();
  }, []);

  const modifyUrl = (modified_query) => {
    const queryString = `?events=${modified_query}`;
    const newUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      queryString;
    window.history.pushState({ path: newUrl }, "", newUrl);
  };

  const clearAll = () =>{
    let temp = reset;
    doReset(temp+1);
    modifyUrl("")
  }

  return (
    <div className="filter-sidebar">
      <div className="filter-header">
        <h2>Filter</h2>
        <div>
          <button
            onClick={clearAll}
            className="clear-filter"
          >
            Clear All
          </button>
        </div>
      </div>
      <div className="filter-types">

          <Filter
          title={orgs.title}
          info={orgs.info}
          options={orgs.options}
          id={orgs.id}
          reset={reset}
          selected={selectedOrgs}
          filter_type="orgs"
        />


        <Filter title={tech.title} info={tech.info} options={tech.options} id={tech.id} reset={reset}/>
        {/* <Filter title={demo.title} info={demo.info} options={demo.options} id={demo.id} reset={reset}/> */}
        {<Filter title={states.title} info={states.info} options={states.options} id={states.id} reset={reset}/>}
        {/* <Filter title={owner.title} info={owner.info} options={owner.options} id={owner.id} reset={reset}/> */}
      </div>
    </div>
  );
}

export default FilterSidebar;
